import { getMatchedMapping } from '../../src';
export var onlyUniqueMappingValidator = function (value, _a) {
    var _b;
    var urlMappingKey = _a.urlMappingKey, urlMappings = _a.urlMappings;
    return !getMatchedMapping((_b = urlMappings.main) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
        var key = _a.key;
        return urlMappingKey !== key;
    }).map(function (_a) {
        var mapping = _a.mapping;
        return mapping;
    }), value);
};
//# sourceMappingURL=only-unique-mapping-validator.js.map